import countriesJson from "../i18n/countries.json";

/** Русское название страны по ISO-коду из `countries.json` (сравнение кода без учёта регистра). */
export function getCountryRuNameByIsoCode(isoCode: string | undefined | null): string | undefined {
    if (isoCode == null || String(isoCode).trim() === "") {
        return undefined;
    }
    const normalized = String(isoCode).trim().toUpperCase();
    const item = countriesJson.find((c) => String(c.code).toUpperCase() === normalized);
    return item?.name?.ru;
}
